/**
 * Ingredient line display: trim and uppercase the first Unicode letter (shop-prototype grocery-item style).
 * Leading non-letters (numbers, punctuation) are left unchanged.
 */
export function capitalizeFirstGroceryWord(name) {
  if (name == null) return ''
  const s = String(name).trim()
  if (!s) return ''
  for (let i = 0; i < s.length; ) {
    const cp = s.codePointAt(i)
    const ch = String.fromCodePoint(cp)
    const next = i + ch.length
    if (/\p{L}/u.test(ch)) {
      return s.slice(0, i) + ch.toLocaleUpperCase() + s.slice(next)
    }
    i = next
  }
  return s
}
